<template>
<el-main v-loading="loading" style="overflow-y:auto;">
    <el-scorll-bar>
        <div style="margin-top: 10px;display: flex;justify-content: center">
            <el-select v-model="deptId" size="small" placeholder="选择项目">
                <el-option v-for="item in dept" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-button type="primary" icon="el-icon-search" size="small" style="margin-left: 3px" @click="searchClick">搜索</el-button>
        </div>
        <div>
            <div class="container">
                <div class="title">编页:</div>
                <div class="echart" id="echart1"></div>
            </div>
            <div class="container">
                <div class="title">平描:</div>
                <div class="echart" id="echart2"></div>
            </div>
            <div class="container">
                <div class="title">高描:</div>
                <div class="echart" id="echart3"></div>
            </div>
            <div class="container">
                <div class="title">图处:</div>
                <div class="echart" id="echart4"></div>
            </div>
            <div class="container">
                <div class="title">质检:</div>
                <div class="echart" id="echart5"></div>
            </div>
            <div class="container">
                <div class="title">著录:</div>
                <div class="echart" id="echart6"></div>
            </div>
            <div class="container">
                <div class="title">校对:</div>
                <div class="echart" id="echart7"></div>
            </div>
            <div class="container">
                <div class="title">装订卷:</div>
                <div class="echart" id="echart8"></div>
            </div>
            <div class="container">
                <div class="title">装订件:</div>
                <div class="echart" id="echart9"></div>
            </div>
        </div>
    </el-scorll-bar>
</el-main>
</template>

<script>
import {
    getRequest,
    postRequest,
    putRequest
} from '../../utils/api'
export default {
    data() {
        return {
            dataSmX: [10, 52, 200, 334, 390, 330, 220],
            dataSmY: [10, 52, 200, 334, 390, 330, 220],
            myChart: ''
        }
    },
    // 页面初始化挂载dom
    mounted() {
        this.loadStatisticsTask()
        // this.getLoadEcharts()
    },
    methods: {
        getLoadEcharts() {
            var option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    data: this.dataSmX,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        interval: 0,
                        rotate: 30
                    }
                }],
                yAxis: [{
                    type: 'value'
                }],
                series: [{
                    name: '工作量',
                    type: 'bar',
                    barWidth: '60%',
                    data: this.dataSmY
                }]
            }
            this.myChart.setOption(option)
        },
        loadProjectList() {
            const _this = this
            var url = '/project/list/' + _this.currentPage + '/' + _this.pageSize
            if (this.keyword !== '') {
                url = url + '&key=' + encodeURIComponent(this.keyword)
            }
            getRequest(url).then(
                resp => {
                    _this.projects = resp.data.data.projects
                    _this.totalCount = resp.data.totalCount
                    _this.loading = false
                },
                resp => {
                    _this.$alert('网络连接错误')
                    _this.loading = false
                }
            )
        },
        loadStatisticsTask() {
            let _this = this
            getRequest('/workload/statisticsTask/0').then(
                resp => {
                    _this.dataSmX = resp.data.data.data01X
                    _this.dataSmY = resp.data.data.data01Y
                    this.myChart = this.$echarts.init(
                        document.getElementById('echart1')
                    )
                    this.getLoadEcharts()

                    _this.dataSmX = resp.data.data.data02X
                    _this.dataSmY = resp.data.data.data02Y
                    this.myChart = this.$echarts.init(
                        document.getElementById('echart2')
                    )
                    this.getLoadEcharts()

                    _this.dataSmX = resp.data.data.data03X
                    _this.dataSmY = resp.data.data.data03Y
                    this.myChart = this.$echarts.init(
                        document.getElementById('echart3')
                    )
                    this.getLoadEcharts()

                    _this.dataSmX = resp.data.data.data04X
                    _this.dataSmY = resp.data.data.data04Y
                    this.myChart = this.$echarts.init(
                        document.getElementById('echart4')
                    )
                    this.getLoadEcharts()

                    _this.dataSmX = resp.data.data.data05X
                    _this.dataSmY = resp.data.data.data05Y
                    this.myChart = this.$echarts.init(
                        document.getElementById('echart5')
                    )
                    this.getLoadEcharts()

                    _this.dataSmX = resp.data.data.data06X
                    _this.dataSmY = resp.data.data.data06Y
                    this.myChart = this.$echarts.init(
                        document.getElementById('echart6')
                    )
                    this.getLoadEcharts()

                    _this.dataSmX = resp.data.data.data07X
                    _this.dataSmY = resp.data.data.data07Y
                    this.myChart = this.$echarts.init(
                        document.getElementById('echart7')
                    )
                    this.getLoadEcharts()

                    _this.dataSmX = resp.data.data.data08X
                    _this.dataSmY = resp.data.data.data08Y
                    this.myChart = this.$echarts.init(
                        document.getElementById('echart8')
                    )
                    this.getLoadEcharts()

                    _this.dataSmX = resp.data.data.data09X
                    _this.dataSmY = resp.data.data.data09Y
                    this.myChart = this.$echarts.init(
                        document.getElementById('echart9')
                    )
                    this.getLoadEcharts()
                },
                resp => {
                    _this.$message.error('网络连接错误')
                    _this.loading = false
                }
            )
        }
    }
}
</script>

<style scoped>
.title {
    text-align: left;
}

.container {
    margin-top: 70px;
    width: 65%;
    height: 400px;
    margin-left: 30px;
    overflow: hidden;
}

.echart {
    width: 100%;
    height: 360px;
    overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/Views/Statistics/StatisticsTask.vue